import { catchError, map, timeout } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Global } from '../../global.constants';
import { Utility } from '../../utility';
import { DBkeys } from '../auth/db-keys';
import { ReadConfigService } from '../common/read-config.service';
const CREATE_ACTION = 'create';
const UPDATE_ACTION = 'update';

@Injectable({
  providedIn: 'root'
})
export class ImportService {
  uploadedFile: any;
  constructor(
    private http: HttpClient,
    private readConfigService: ReadConfigService) { }

  readonly rootUrl = this.readConfigService.getApiUrl();
  apiTimeout = this.readConfigService.getApiTimeout();
  reqHeader = new HttpHeaders({ 'Content-Type': 'application/json' });
  reqNoAuthHeader = new HttpHeaders({ 'No-Auth': 'True' });
  private data: any[] = [];

  UserInfo(): any {
    const userInfo = {
      encryptOrg: Utility.removeQuotes(sessionStorage.getItem(DBkeys.ENC_ORGID)),
      encryptUsr: Utility.removeQuotes(sessionStorage.getItem(DBkeys.ENC_USER))
    };
    return userInfo;
  }

  saveFileUpload(file: any) {
    this.uploadedFile = file;
  }

  getFileUpload() {
    return this.uploadedFile;
  }

  uploadImportFile(file: any, scheduleEntryId: any): Observable<any> {
    const formData: FormData = new FormData();
    const userInfo = this.UserInfo();
    formData.append('userInfo', JSON.stringify(userInfo));
    formData.append('uploadFile', file[0].rawFile);
    formData.append('scheduleEntryId', scheduleEntryId);
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    const url = this.rootUrl + Global.BASE_IMPORT_FROM_FILE_ENDPOINT;
    return this.http.post<any>(url, formData, { headers })
      .pipe(this.handleError());
  }

  getImports(): Observable<any> {
    const userInfo = this.UserInfo();
    const obj = { userInfo };
    const url = this.rootUrl + Global.BASE_IMPORT_ENDPOINT;
    return this.http.post<any>(url, obj, { headers: this.reqHeader })
      .pipe(this.handleError());
  }

  isPpedExists(id: number, orgId: number, pped: Date): Observable<any> {
    const url = this.rootUrl + Global.BASE_IMPORT_PPEDEXISTS_ENDPOINT;
    const userInfo = this.UserInfo();
    const obj = { importId: id, orgId: orgId.toString(), pped: pped.toDateString(), userInfo };
    return this.http.post<any>(url, obj, { headers: this.reqHeader })
      .pipe(this.handleError());
  }

  cloneImport(id: number, pped: Date, scheduleEntryId: number): Observable<any> {
    const url = this.rootUrl + Global.BASE_IMPORT_CLONE_ENDPOINT;
    const userInfo = this.UserInfo();
    const obj = { importId: id, pped: pped.toDateString(), scheduleEntryId, userInfo };
    return this.http.post<any>(url, obj, { headers: this.reqHeader })
      .pipe(this.handleError());
  }

  continueUpload(id: number): Observable<any> {
    const url = this.rootUrl + Global.BASE_IMPORT_CONTINUE_UPLOAD_ENDPOINT;
    const userInfo = this.UserInfo();
    const obj = { importId: id.toString(), userInfo };
    return this.http.post<any>(url, obj, { headers: this.reqHeader })
      .pipe(this.handleError());
  }

  getPreSubmitData(importId: string): Observable<any> {
    const url = this.rootUrl + Global.BASE_IMPORT_PRESUBMIT_ENDPOINT;
    const userInfo = this.UserInfo();
    const obj = { importId: importId.toString(), userInfo };
    return this.http.post<any>(url, obj, { headers: this.reqHeader })
      .pipe(this.handleError());
  }

  submitImport(id: number): Observable<any> {
    const url = this.rootUrl + Global.BASE_IMPORT_SUBMIT_IMPORT_ENDPOINT;
    const userInfo = this.UserInfo();
    const obj = { importId: id.toString(), userInfo };
    return this.http.post<any>(url, obj, { headers: this.reqHeader })
      .pipe(this.handleError());
  }

  getImportErrors(id: number): Observable<any> {
    const url = this.rootUrl + Global.BASE_IMPORT_ERRORS_ENDPOINT;
    const userInfo = this.UserInfo();
    const obj = { importId: id, userInfo };
    return this.http.post<any>(url, obj, { headers: this.reqHeader })
      .pipe(this.handleError());
  }

  getIssues(id: number): Observable<any> {
    const url = this.rootUrl + Global.BASE_IMPORT_ISSUE_ENDPOINT;
    const userInfo = this.UserInfo();
    const obj = { importId: id, userInfo };
    return this.http.post<any>(url, obj, { headers: this.reqHeader })
      .pipe(this.handleError());
  }

  deleteImport(id: number, invoiceId: number): Observable<any> {
    const url = this.rootUrl + Global.BASE_IMPORT_DELETE_ENDPOINT;
    const userInfo = this.UserInfo();
    const obj = { importId: id.toString(), invoiceId, userInfo };
    return this.http.post<any>(url, obj, { headers: this.reqHeader })
      .pipe(this.handleError());
  }

  deleteUnValidatedImports(): Observable<any> {
    const url = this.rootUrl + Global.BASE_IMPORT_DELETE_UNSUB_IMPORT_ENDPOINT;
    const userInfo = this.UserInfo();
    const obj = { userInfo };
    return this.http.post<any>(url, obj, { headers: this.reqHeader })
      .pipe(this.handleError());
  }

  getRecords(id: number, staging: boolean): Observable<any> {
    const url = this.rootUrl + Global.BASE_RECORD_ENDPOINT;
    const userInfo = this.UserInfo();
    const obj = { importId: id, isStaging: staging, userInfo };
    return this.http.post<any>(url, obj, { headers: this.reqHeader })
      .pipe(this.handleError());
  }

  getIssueRecords(id: number, issueType: string, staging: boolean, isError: boolean): Observable<any> {
    const url = this.rootUrl + Global.BASE_ISSUE_RECORD_ENDPOINT;
    const userInfo = this.UserInfo();
    const obj = { importId: id, issueType, isStaging: staging, userInfo, isError };
    return this.http.post<any>(url, obj, { headers: this.reqHeader })
      .pipe(this.handleError());
  }

  generateImportFile(importId: string) {
    const url = this.rootUrl + Global.BASE_FILE_DOWNLOAD_ENDPOINT;
    const userInfo = this.UserInfo();
    const obj = { importId: importId.toString(), userInfo };
    return this.http.post<any>(url, obj, { headers: this.reqHeader })
      .pipe(this.handleError());
  }

  getStates(isPayroll: boolean): Observable<any> {
    const url = this.rootUrl + (isPayroll ? Global.BASE_STATES_ENDPOINT : Global.BASE_ENROLLMENT_AUTHORIZED_STATES_ENDPOINT);
    const userInfo = this.UserInfo();
    const obj = { userInfo };
    return this.http.post<any>(url, obj, { headers: this.reqHeader })
      .pipe(this.handleError());
  }

  getValidationSettings(): Observable<any> {
    const url = this.rootUrl + Global.BASE_IMPORT_VALIDATIONS_ENDPOINT;
    const userInfo = this.UserInfo();
    const obj = { userInfo };
    return this.http.post<any>(url, obj, { headers: this.reqHeader })
      .pipe(this.handleError());
  }

  save(data: any, isNew?: boolean): Observable<any> {
    const action = isNew ? CREATE_ACTION : UPDATE_ACTION;
    this.reset();
    if (action === CREATE_ACTION) {
      return this.createRecord(data);
    } else {
      return this.updateRecord(data);
    }
  }

  createRecord(data: any): Observable<any> {
    const url = this.rootUrl + Global.BASE_RECORD_CREATE_ENDPOINT;
    const userInfo = this.UserInfo();
    data.userInfo = userInfo;
    return this.http.post<any>(url, data)
      .pipe(this.handleError());
  }

  updateRecord(data: any): Observable<any> {
    const url = this.rootUrl + Global.BASE_RECORD_UPDATE_ENDPOINT;
    const userInfo = this.UserInfo();
    data.userInfo = userInfo;
    return this.http.post<any>(url, data)
      .pipe(this.handleError());
  }

  remove(data: any): Observable<any> {
    this.reset();
    const url = this.rootUrl + Global.BASE_RECORD_DELETE_ENDPOINT;
    const body = data.dataItem;
    const userInfo = this.UserInfo();
    body.userInfo = userInfo;
    return this.http.post<any>(url, body)
      .pipe(this.handleError());
  }

  private reset() {
    this.data = [];
  }

  handleError() {
    return timeout(this.apiTimeout),
      catchError((err: any) => {
        return throwError(err || 'Server error');
      }),
      map((v: any) => {
        if (v) {
          return v;
        }
      });
  }
}
